/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var MultiHook = /*#__PURE__*/ function() {
    function MultiHook(hooks) {
        var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
        _class_call_check._(this, MultiHook);
        this.hooks = hooks;
        this.name = name;
    }
    _create_class._(MultiHook, [
        {
            key: "tap",
            value: function tap(options, fn) {
                var hooks = this.hooks;
                for(var i = 0; i < hooks.length; i++){
                    hooks[i].tap(options, fn);
                }
            }
        },
        {
            key: "tapAsync",
            value: function tapAsync(options, fn) {
                var hooks = this.hooks;
                for(var i = 0; i < hooks.length; i++){
                    hooks[i].tapAsync(options, fn);
                }
            }
        },
        {
            key: "tapPromise",
            value: function tapPromise(options, fn) {
                var hooks = this.hooks;
                for(var i = 0; i < hooks.length; i++){
                    hooks[i].tapPromise(options, fn);
                }
            }
        },
        {
            key: "isUsed",
            value: function isUsed() {
                var hooks = this.hooks;
                for(var i = 0; i < hooks.length; i++){
                    if (hooks[i].isUsed()) return true;
                }
                return false;
            }
        },
        {
            key: "intercept",
            value: function intercept(interceptor) {
                var hooks = this.hooks;
                for(var i = 0; i < hooks.length; i++){
                    hooks[i].intercept(interceptor);
                }
            }
        },
        {
            key: "withOptions",
            value: function withOptions(options) {
                return new MultiHook(this.hooks.map((hook)=>hook.withOptions(options)), this.name);
            }
        }
    ]);
    return MultiHook;
}();
module.exports = MultiHook;
